import logoPC from "../../assets/logo.png"
import logoBP from "../../assets/logoBP.png"
import logoCE from "../../assets/logoCE.png"
import {format} from 'date-fns'
import 'react-day-picker/dist/style.css'
import {useRef, useState} from "react";
import DayPicking from "../Form/DayPicking";
import fr from "date-fns/locale/fr"
import ReactSelectAgences from "../Form/ReactSelectAgences";
import axios from "axios"
import {getApiUrl} from "../../utils/getApiUrl";
import Popin from "../Popin/Popin";
import ReactSelectTime from "../Form/ReactSelectTime";
import Footer from "../Layout/Footer";

function AppConseiller(etablissement) {
    console.log("etablissemntconseiler", etablissement)
    const [showDate, setShowDate] = useState(false)
    const [selected, setSelected] = useState()
    const [message, setMessage] = useState("")
    const [errorFormApi, setErrorFormApi] = useState(false)
    const [popin, setPopin] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [classNamePrenomClientInput, setClassNamePrenomClientInput] = useState("")
    const [classNamePrenomConseillerInput, setClassNamePrenomConseillerInput] = useState("")
    const [classNameNomClientInput, setClassNameNomClientInput] = useState("")
    const [classNameNomConseillerInput, setClassNameNomConseillerInput] = useState("")
    const [classNameMailClientInput, setClassNameMailClientInput] = useState("")
    const [classNameMailConseillerInput, setClassNameMailConseillerInput] = useState("")
    const [classNameTelInput, setClassNameTelInput] = useState("")
    const [classNameDateInput, setClassNameDateInput] = useState("")
    const [classNameDayPicker, setClassNameDayPicker] = useState("")

    const [errMessClientPrenom, setErrMessClientPrenom] = useState("")
    const [errMessConseillerPrenom, setErrMessConseillerPrenom] = useState("")
    const [errMessClientNom, setErrMessClientNom] = useState("")
    const [errMessConseillerNom, setErrMessConseillerNom] = useState("")
    const [errMessageTelInput, setErrMessageTelInput] = useState("")
    const [errMessClientMail, setErrMessClientMail] = useState("")
    const [errMessConseillerMail, setErrMessConseillerMail] = useState("")

    let date;
    if (selected) {
        date = "Le " + format(selected, 'EEEEEEEEE' + " dd" + " MMMM", {locale: fr})
    }

    // DATA A ENVOYER À L'API
    // ref
    const refClientPrenom = useRef(null)
    const refClientNom = useRef(null)
    const refClientEmail = useRef(null)
    const refTel = useRef(null)
    const refDay = useRef(null)
    const refTime = useRef(null)
    const refConseillerPrenom = useRef(null)
    const refConseillerNom = useRef(null)
    const refConseillerEmail = useRef(null)
    const refConseillerAgence = useRef(null)
    let time;

    // ENVOI DU FORMULAIRE
    const handleForm = (e) => {
        setIsLoading(true)
        setMessage("")
        setErrorFormApi(false)
        e.preventDefault();
        // console.log(refClientPrenom)
        if (
            refClientPrenom.current.value === "" ||
            refClientNom.current.value === "" ||
            refClientEmail.current.value === "" ||
            refTel.current.value === "" ||
            refConseillerPrenom.current.value === "" ||
            refConseillerNom.current.value === "" ||
            refConseillerEmail.current.value === "" ||
            refConseillerAgence.current.state.value === null
        ) {
            setIsLoading(false)
            setMessage("Vous devez compléter tous les champs obligatoires pour soumettre votre demande.")
        } else if (
            (errMessClientPrenom ||
                errMessConseillerPrenom ||
                errMessClientNom ||
                errMessConseillerNom ||
                errMessageTelInput ||
                errMessClientMail ||
                errMessConseillerMail) !== ""
        ) {
            setIsLoading(false)
            setMessage("Votre formulaire n'est pas conforme, veuillez vérifier les informations saisies.")
        } else {
            let time = document.getElementsByClassName("select-search-input")
            time = time[0].value
            let data = new FormData();
            data.append('prenom', refClientPrenom.current.value)
            data.append('prenomConseiller', refConseillerPrenom.current.value)
            data.append('nom', refClientNom.current.value)
            data.append('nomConseiller', refConseillerNom.current.value)
            data.append('email', refClientEmail.current.value)
            data.append('emailConseiller', refConseillerEmail.current.value)
            data.append('tel', refTel.current.value)
            data.append('day', refDay.current.value)
            data.append('time', time)
            data.append('agence', JSON.stringify(refConseillerAgence.current.state.value))
            data.append('banque', JSON.stringify(etablissement))

            axios.post(`${getApiUrl()}/createBPCE/index.php`,
                data,
                {withCredentials: true}
            )
                .then(() => {
                    console.log("onyest?", {
                        client: {
                            prenom: refClientPrenom.current.value,
                            nom: refClientNom.current.value,
                            email: refClientEmail.current.value,
                            tel: refTel.current.value,
                            day: refDay.current.value,
                            time: time
                        },
                        conseiller: {
                            prenom: refConseillerPrenom.current.value,
                            nom: refConseillerNom.current.value,
                            email: refConseillerEmail.current.value,
                            agence: refConseillerAgence.current.state.value
                        }
                    })
                })
                .then((res) => {
                    console.log("res", res)
                    setIsLoading(false)
                    setPopin(true)
                    setErrorFormApi(false)
                })
                .catch((err) => {
                    console.log("err", err)
                    setIsLoading(false)
                    setErrorFormApi(true)
                    setPopin(false)
                });
        }
    }


    return (
        <div className="App">
            <header>
                <div className={"logo prevandcare"}>
                    <a href={"https://www.prevandcare.com"}
                       target="_blank" rel="noreferrer"><img src={logoPC}/></a>
                </div>
                <div className={"logo text"}><p>en partenariat avec</p></div>
                <div className={"logo bpce"}>
                    {etablissement.etablissement === "bp"
                        ? <img src={logoBP}/>
                        : <img src={logoCE}/>
                    }
                </div>
            </header>
            <main>
                <div className={"intro"}>
                    <h1>
                        Demande de <div className={"nauticus"}>contact</div>
                    </h1>
                    <p>
                        Ce formulaire vous permet de transmettre, suite à accord de votre client, une demande de contact
                        à notre partenaire Prev&Care, spécialisé dans l’accompagnement des aidants familiaux et de leurs
                        proches.
                        Votre client sera rappelé gratuitement par un assistant personnel Prev&Care pour découvrir
                        l’accompagnement proposé.
                    </p>
                </div>
                <div className={"form client"}>
                    <h2>Coordonnées de votre client</h2>
                    <form
                        id={"client-form"}
                        onSubmit={(e) => e.preventDefault()}>
                        <div className={"input-container small"}>
                            <input
                                required
                                type={"text"}
                                ref={refClientPrenom}
                                onFocus={() => setClassNamePrenomClientInput("active")}
                                onChange={() => {
                                    if (/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(refClientPrenom.current.value))
                                        setErrMessClientPrenom("")
                                    else setErrMessClientPrenom("Le format de votre prénom est incorrect")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNamePrenomClientInput}>Prénom *</p>
                            </div>
                            <span className={"errMessage"}>{errMessClientPrenom}</span>
                        </div>
                        <div className={"input-container small"}>
                            <input
                                required
                                type={"text"}
                                ref={refClientNom}
                                onFocus={() => setClassNameNomClientInput("active")}
                                onChange={() => {
                                    if (/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(refClientNom.current.value))
                                        setErrMessClientNom("")
                                    else setErrMessClientNom("Le format de votre nom est incorrect")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNameNomClientInput}>Nom *</p>
                            </div>
                            <span className={"errMessage"}>{errMessClientNom}</span>
                        </div>
                        <div className={"input-container"}>
                            <input
                                required
                                type={"text"}
                                ref={refClientEmail}
                                onFocus={() => setClassNameMailClientInput("active")}
                                onChange={() => {
                                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(refClientEmail.current.value))
                                        setErrMessClientMail("")
                                    else setErrMessClientMail("Votre adresse mail doit être au format : xxxxx@xxxx.xx")
                                }}
                            />
                            <div className={"placeholder"}>
                                <p className={classNameMailClientInput}>Adresse e-mail *</p>
                            </div>
                            <span className={"errMessage"}>{errMessClientMail}</span>
                        </div>
                        <div className={"input-container"}>
                            <input
                                required
                                type={"tel"}
                                ref={refTel}
                                onFocus={() => setClassNameTelInput("active")}
                                onChange={() => {
                                    if (/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(refTel.current.value))
                                        setErrMessageTelInput("")
                                    else setErrMessageTelInput("Votre numéro de téléphone doit contenir au minimum 10 chiffres")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNameTelInput}>Numéro de téléphone *</p>
                            </div>
                            <span className={"errMessage"}>{errMessageTelInput}</span>
                        </div>
                        <div className={`input-container ${classNameDateInput} dayContainer`}>
                            <input
                                onFocus={(() => {
                                    setClassNameDateInput("active")
                                    setShowDate(true);
                                    setClassNameDayPicker("behind")
                                })}
                                value={selected && date}
                                ref={refDay}
                                onBlur={() => {
                                    setTimeout(() => {
                                        setShowDate(false)
                                    }, 999999)
                                }}
                            />
                            <div className={"placeholder"}>
                                <p className={classNameDateInput}>Choisissez une date</p>
                            </div>
                            <div id={"picker-container"}>
                                {showDate &&
                                    <DayPicking
                                        selected={selected}
                                        setSelected={setSelected}
                                        date={date}
                                        setShowDate={setShowDate}/>
                                }
                            </div>
                        </div>
                        <ReactSelectTime refTime={refTime} refAgence={refConseillerAgence}/>
                        <span>Si aucun créneau/date de rappel n’est renseigné, votre client sera rappelé dans les 48h.</span>
                    </form>
                </div>
                <div className={"form conseiller"}>
                    <h2>
                        Vos coordonnées
                    </h2>
                    <form
                        id={"conseiller-form"}
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <div className={"input-container small"}>
                            <input
                                required
                                type={"text"}
                                ref={refConseillerPrenom}
                                onFocus={() => setClassNamePrenomConseillerInput("active")}
                                onChange={() => {
                                    if (/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(refConseillerPrenom.current.value))
                                        setErrMessConseillerPrenom("")
                                    else setErrMessConseillerPrenom("Le format de votre prénom est incorrect")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNamePrenomConseillerInput}>Votre prénom *</p>
                            </div>
                            <span className={"errMessage"}>{errMessConseillerPrenom}</span>
                        </div>
                        <div className={"input-container small"}>
                            <input
                                required
                                type={"text"}
                                ref={refConseillerNom}
                                onFocus={() => setClassNameNomConseillerInput("active")}
                                onChange={() => {
                                    if (/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(refConseillerNom.current.value))
                                        setErrMessConseillerNom("")
                                    else setErrMessConseillerNom("Le format de votre prénom est incorrect")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNameNomConseillerInput}>Votre nom *</p>
                            </div>
                            <span className={"errMessage"}>{errMessConseillerNom}</span>
                        </div>
                        <div className={"input-container"}>
                            <input
                                required
                                type={"text"}
                                ref={refConseillerEmail}
                                onFocus={() => setClassNameMailConseillerInput("active")}
                                onChange={() => {
                                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(refConseillerEmail.current.value))
                                        setErrMessConseillerMail("")
                                    else setErrMessConseillerMail("Votre adresse mail doit être au format : xxxxx@xxxx.xx")
                                }}
                            />
                            <div className={"placeholder"}>
                                <p className={classNameMailConseillerInput}>Votre adresse e-mail *</p>
                            </div>
                            <span className={"errMessage"}>{errMessConseillerMail}</span>
                        </div>

                        <ReactSelectAgences refConseillerAgence={refConseillerAgence} etablissement={etablissement}/>
                    </form>
                </div>
                {errorFormApi &&
                    <p className={"errorMessage"}>Il y a eu une erreur lors de l'envoi de votre formulaire. Vérifiez
                        votre connexion internet et
                        réessayez. Si le problème persiste, vous pouvez nous contacter <a
                            href={"https://www.prevandcare.com/aidants-familiaux-care-manager-contact.php"}
                            target="_blank"
                            style={{textDecoration: "none", color: "red", fontWeight: 800}} rel="noreferrer">ici</a> par
                        téléphone ou par
                        mail.</p>
                }
                <p className={"footMessage"}>* Champ obligatoire.</p>
                <p className={"errorMessage"}>{message}</p>

                {popin &&
                    <Popin prenom={refClientPrenom} email={refClientEmail}/>
                }
                <div className={"button-block"}>
                    <button
                        type={"submit"}
                        form={"client-form"}
                        form={"conseiller-form"}
                        onClick={handleForm}
                    >
                        Envoyer la demande de rappel
                    </button>

                </div>
            </main>
            <Footer/>
        </div>
    );
}

export default AppConseiller;
